module.exports = __webpack_public_path__ + "img/23.4a02ab19.jpg";